import { z } from 'zod';
import { PART_CONSTRAINTS } from './constraints.js';
export const partUrlSchema = z
    .string()
    .trim()
    .max(PART_CONSTRAINTS.url.maxLength)
    .refine((value) => value === '' || /^https?:\/\//i.test(value), {
    message: 'URL must start with http:// or https://.',
});
//# sourceMappingURL=part-url.js.map